import { Brand, Stage } from '@org-avp/models';
export const getDefaultIdleApp = (stage, brand) => {
    const data = idleAppDefaults[brand]?.[stage];
    if (!data)
        return null;
    const owner = typeof data.owner === 'function' ? data.owner(data.url) : data.owner;
    return {
        url: data.url,
        owner,
        config: data.config,
    };
};
export const defaultIdleAppOwnerFn = (url) => new URL(url).hostname;
export const defaultIdleAppConfig = (stage) => JSON.stringify(`Device registered on ${stage} stage. All systems nominal. Don't panic 🚀`);
const IDLE_APP_CONFIG_URL_MAP = {
    [Stage.DEVELOP]: {
        'https://naap-demo-iframe-app.develop.avp.tech': 'https://naap-demo-iframe-app.develop.avp.tech',
        'https://pwa.int.newretail.avp.tech': 'https://pwa.int.newretail.avp.tech/editMode',
    },
    [Stage.PREPROD]: {
        'https://pwa.int.newretail.avp.tech': 'https://pwa.int.newretail.avp.tech/editMode',
    },
    [Stage.PROD]: {},
};
/**
 * Returns the config page URL for the given idle app URL on the given stage,
 * or `undefined` if no config page is registered.
 */
export function getIdleAppConfigUrl(stage, idleAppUrl) {
    try {
        const origin = new URL(idleAppUrl).origin;
        return IDLE_APP_CONFIG_URL_MAP[stage]?.[origin];
    }
    catch {
        return undefined;
    }
}
export const idleAppDefaults = {
    [Brand.AUDI]: {
        [Stage.DEVELOP]: {
            url: 'https://naap-demo-iframe-app.develop.avp.tech',
            owner: defaultIdleAppOwnerFn,
            config: defaultIdleAppConfig(Stage.DEVELOP),
        },
        [Stage.PREPROD]: {
            url: 'https://pwa.int.newretail.avp.tech/?displayName=123',
            owner: defaultIdleAppOwnerFn,
            config: defaultIdleAppConfig(Stage.PREPROD),
        },
        [Stage.PROD]: {
            url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
            owner: 'api.prod.newretail.avp.tech',
            config: null,
        },
    },
    [Brand.BENTLEY]: {
        // [Stage.DEVELOP]: {}
        // [Stage.PREPROD]: {}
        [Stage.PROD]: {
            url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
            owner: 'api.prod.newretail.avp.tech',
            config: null,
        },
    },
    [Brand.SEAT]: {
        // [Stage.DEVELOP]: {}
        // [Stage.PREPROD]: {}
        [Stage.PROD]: {
            url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
            owner: 'api.prod.newretail.avp.tech',
            config: null,
        },
    },
    [Brand.VW]: {
        [Stage.DEVELOP]: {
            url: 'https://naap-demo-iframe-app.develop.avp.tech',
            owner: defaultIdleAppOwnerFn,
            config: defaultIdleAppConfig(Stage.DEVELOP),
        },
        [Stage.PREPROD]: {
            url: 'https://pwa.int.newretail.avp.tech/?displayName=123',
            owner: defaultIdleAppOwnerFn,
            config: defaultIdleAppConfig(Stage.PREPROD),
        },
        [Stage.PROD]: {
            url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
            owner: 'api.prod.newretail.avp.tech',
            config: null,
        },
    },
    [Brand.VW_NUTZFAHRZEUGE]: {
        // [Stage.DEVELOP]: {}
        // [Stage.PREPROD]: {}
        [Stage.PROD]: {
            url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
            owner: 'api.prod.newretail.avp.tech',
            config: null,
        },
    },
};
//# sourceMappingURL=config.js.map